import { normalizeIcd10Key } from '@seen/core/models/organizationConditionsList'
import { compact } from 'lodash-es'
import type { ConditionPickerCondition } from '#src/components/condition-picker/types.ts'

export function rowIcd10Codes(condition: ConditionPickerCondition): string[] {
  if (condition.orgTemplate) {
    return compact(condition.orgTemplate.icd10Codes.map((c) => c.code)).map(
      normalizeIcd10Key
    )
  }
  if (condition.icd10Result?.code) {
    return [normalizeIcd10Key(condition.icd10Result.code)]
  }
  if (condition.diagnosis) {
    return condition.diagnosis.icd10Codes.map(normalizeIcd10Key)
  }
  return []
}
